import { styled } from '@mui/material/styles';
import { Box, Typography, TextField, Radio } from '@mui/material';
import CommonSegmentedControl from '../../../../form-components/CommonSegmentedControl';

// ============================================
// Modal Container
// ============================================
export const ModalOverlay = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1300,
});

export const ModalContainer = styled(Box)({
  width: '500px',
  maxHeight: '90vh',
  backgroundColor: '#fff',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
});

// ============================================
// Header
// ============================================
export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 24px',
  backgroundColor: '#262626',
});

export const ModalTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#fff',
});

export const CloseButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: '#fff',
  '&:hover': {
    opacity: 0.8,
  },
});

// ============================================
// Content
// ============================================
export const ModalContent = styled(Box)({
  padding: '24px',
  maxHeight: 'calc(90vh - 140px)',
  overflowY: 'auto',
});

// ============================================
// Tab Group
// ============================================
export const TabGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0px',
  marginBottom: '24px',
});

export const Tab = styled(Box, {
  shouldForwardProp: prop => prop !== 'isActive',
})(({ isActive }) => ({
  flex: 1,
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
  fontWeight: 500,
  cursor: 'pointer',
  border: '1px solid',
  borderColor: isActive ? '#262626' : '#d9d9d9',
  backgroundColor: isActive ? '#262626' : '#f5f5f5',
  color: isActive ? '#fff' : '#666',
  transition: 'all 0.2s ease',
  '&:first-of-type': {
    borderRadius: '8px 0 0 8px',
    borderRight: 'none',
  },
  '&:last-of-type': {
    borderRadius: '0 8px 8px 0',
    borderLeft: 'none',
  },
  '&:not(:first-of-type):not(:last-of-type)': {
    borderRadius: '0',
  },
}));

// ============================================
// Description
// ============================================
export const DescriptionText = styled(Typography)({
  fontSize: '16px',
  color: '#262626',
  marginBottom: '16px',
  '& .required': {
    color: '#EE735A',
    marginLeft: '2px',
  },
  '& .sub-text': {
    color: '#0F7F85',
    fontSize: '13px',
  },
});

// ============================================
// Radio Options
// ============================================
export const RadioOptionList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

export const RadioOption = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSelected',
})(({ isSelected }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  ...(isSelected && {
    '& .MuiRadio-root': {
      color: '#0F7F85',
    },
  }),
}));

export const StyledRadio = styled(Radio)({
  padding: '4px',
  color: '#d9d9d9',
  '&.Mui-checked': {
    color: '#0F7F85',
  },
});

export const RadioLabel = styled(Typography)({
  fontSize: '16px',
  color: '#262626',
});

// ============================================
// Custom Input Option
// ============================================
export const CustomInputWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const SmallInput = styled(TextField)({
  width: '60px',
  '& .MuiOutlinedInput-root': {
    height: '32px',
    '& input': {
      padding: '4px 8px',
      fontSize: '14px',
      textAlign: 'center',
    },
    '& fieldset': {
      borderColor: '#d9d9d9',
    },
    '&:hover fieldset': {
      borderColor: '#0F7F85',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0F7F85',
    },
  },
});

// ============================================
// Footer
// ============================================
export const ModalFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '20px 24px',
  borderTop: '1px solid #e5e5e5',
});

// 직접입력 단위 토글 (회/일 ↔ %) — 공용 세그먼트 컨트롤을 인라인 크기로 축소해서 사용
export const UnitSegmentedControl = styled(CommonSegmentedControl)({
  width: 'auto',
  gap: '4px',
  flexShrink: 0,
  '& .MuiButton-root': {
    flex: '0 0 auto',
    height: '32px',
    minWidth: 0,
    padding: '0 10px',
    fontSize: '13px',
  },
});
